import {Kind} from "graphql";
import uploads from "./uploads";
export default {
    [Kind.INPUT_OBJECT_TYPE_DEFINITION](node){
        return uploads(node)
    }
}
